import { useTranslation } from "react-i18next";
import { Klassen } from "@/features/stamgegevens/Klassen";
import { BeheerderShell } from "@/components/BeheerderShell";

export function KlassenPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.klassen.label")}
      uitleg={t("klassen.uitleg")}
    >
      <Klassen />
    </BeheerderShell>
  );
}
